import { COMPANY_BRAND } from '../brand';
import { useT } from '../i18n';
import styles from './ProductBrand.module.css';

/** One brand lockup for the home, navigation and welcome surfaces. */
export function ProductBrand({ hero = false }: { hero?: boolean }) {
  const t = useT();
  return (
    <div className={`${styles.brand}${hero ? ` ${styles.hero}` : ''}`}>
      <span className={styles.avatar} aria-hidden="true">
        <img src={COMPANY_BRAND.avatar} alt="" width={96} height={96} />
      </span>
      <span className={styles.copy}>
        <strong>{COMPANY_BRAND.name}</strong>
        <span>{t('company.workspaceTagline')}</span>
      </span>
    </div>
  );
}
